/* eslint-disable import/default */
// import { applyMiddleware } from "redux";
// import { composeWithDevTools } from "redux-devtools-extension";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";
// eslint-disable-next-line import/namespace
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: rootReducer,
  Middleware: [thunk],
});

export default store;
